const modelEmailFactory = () => JSON.parse(JSON.stringify(emailModel))
const modelSmsFactory = () => JSON.parse(JSON.stringify(smsModel))

let smsModel = {
  channel: 2,
  audience: {
    override: false,
    segments: [],
    totalContacts: 0,
    targetAudienceType: '',
  },
  content: {
    templateId: '',
    senderId: '',
    senderName: '',
    content: '',
    contentType: '',
    isNewContent: true,
  },
  time: {
    scheduleDate: '',
    endTime: '',
    timezone: '',
    beginTime: '',
    targetTimeType: null,
    isWorkingDays: true,
    scheduleTime: '',
  },
  conditions: [],
}

let emailModel = {
  channel: 1,
  audience: {
    override: false,
    segments: [],
    totalContacts: 0,
    targetAudienceType: '',
  },
  content: {
    from: '',
    content: '',
    replyTo: '',
    subject: '',
    senderId: '',
    senderName: '',
    templateId: '',
    contentType: null,
    displayName: '',
    thumbnailUri: '',
    htmlFileUri: '',
    templateName: '',
    emailSimpleText: '',
    emailPrefix: '',
  },
  time: {
    scheduleDate: '',
    endTime: '',
    timezone: '',
    beginTime: '',
    targetTimeType: '',
    isWorkingDays: true,
    scheduleTime: '',
  },
  conditions: [],
}

let models = [
  {
    name: 'custom',
    content: {
      _id: '',
      campaignId: '',
      organizationUserId: '',
      type: 'CUSTOM',
      name: '',
      status: 'SETUP',
      sends: '0',
      opens: '0',
      clicks: '0',
      values: [],
    },
  },
  {
    name: 'sms',
    content: {
      _id: '',
      campaignId: '',
      organizationUserId: '',
      type: 'SMS',
      name: '',
      status: 'SETUP',
      sends: '0',
      opens: '0',
      clicks: '0',
      values: [
        { ...smsModel },
        // MODELO ANTIGO PARA BKP
        // {
        //   "channel": "SMS",
        //   "audience": {
        //     "segments": [],
        //     "override": false,
        //     "targetAudience": '',
        //     'totalContacts': null
        //   },
        //   "content": {
        //     "templateId": "",
        //     "content": "",
        //     "contentType": "",
        //     "senderId": "",
        //     "senderName": "",
        //     "isNewContent": null,
        //     "targetSMSContent": "",
        //   },
        //   "time": {
        //     "scheduleDate": {},
        //     "beginTime": '',
        //     "endTime": '',
        //     "timeZone": '',
        //     "targetTimeType": '',
        //     "scheduleTime": "string",
        //     "isWorkingDays": false
        //   },
        //   "conditions": []
        // }
      ],
    },
  },
  {
    name: 'email',
    content: {
      _id: '',
      campaignId: '',
      organizationUserId: '',
      type: 'EMAIL',
      name: '',
      status: 'SETUP',
      sends: '0',
      opens: '0',
      clicks: '0',
      values: [
        { ...emailModel },
        // MODELO ANTIGO PARA BKP
        // {
        //   "channel": "EMAIL",
        //   "audience": {
        //     "segments": [],
        //     "override": false,
        //     "targetAudience": '',
        //     'totalContacts': null
        //   },
        //   "content": {
        //     "from": "",
        //     "replyTo": "",
        //     "templateId": "",
        //     "subject": "",
        //     "displayName": "",
        //   },
        //   "time": {
        //     "scheduleDate": {},
        //     "beginTime": '',
        //     "endTime": '',
        //     "timeZone": '',
        //     "targetTimeType": '',
        //     "scheduleTime": "string",
        //     "isWorkingDays": null
        //   },
        //   "conditions": []
        // },
      ],
    },
  },
  {
    name: 'sms+email',
    content: {
      _id: '',
      campaignId: '',
      organizationUserId: '',
      type: 'SMS+EMAIL',
      name: '',
      status: 'SETUP',
      sends: '0',
      opens: '0',
      clicks: '0',
      values: [modelSmsFactory(), modelEmailFactory()],
    },
  },
]

export function getModels(name) {
  if (name) {
    let temp = models.find(item => item.name == name)
    return JSON.parse(JSON.stringify(temp.content))
  }
  return ' '
}

export { smsModel, emailModel, modelEmailFactory, modelSmsFactory }
